import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { OrganizationRole } from "../../common/models/organization-role";
import { User } from "../../common/models/user";
import { EvaluationAthlete } from "../../common/models/evaluation-athlete";
import { AthleteCoach } from "../../common/models/athlete-coach";
import { AthleteGuest } from "../../common/models/athlete-guest";
import { OrganizationMembership } from "../../common/models/organization-membership";
import { Coach } from "../../common/models/coach";
import { Athlete } from "../../common/models/athlete";
import { Guest } from "../../common/models/guest";


export class EvaluationAthleteRights {
    public Ready: Promise<boolean> = new Promise((resolve, reject) => reject(false));
    private _itemRightsList: EvaluationAthleteItemRightsList | null = null;
    private _screenRightsList: EvaluationAthleteScreenRightList | null = null;
    private _paramsItem: EvaluationAthleteItemRightsParams | null = null;
    private _paramsScreen: EvaluationAthleteScreenRightsParams | null = null;
    private _bestOfItemRight = 10000;
    private _bestOfScreenRight = 10000;
    constructor(private _utils: UtilsProvider) {
        this.setDefault();
    }


    public evaluateItemRight(params: EvaluationAthleteItemRightsParams): void {

        /**
         * Les paramètres reçus contiennent le athlete, le user.id
         * et le organizationId. Les droits évalués doivent répondrent
         * à la question : qu'est-ce que je (user.id) peux faire avec
         * cet athlète (athlete.id) dans cette organisation (organizationId)
         * avec mon rôle (this._bestOfItemRight).
         */

        this._paramsItem = params;
        this.setDefault();
        this.setBestOfRole();

        const evalAthlete = this._paramsItem.evaluationAthlete;

        if(!this._itemRightsList) return;

        switch (this._bestOfItemRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            // tous les évaluations athlètes
            this._itemRightsList.view = true;
            this._itemRightsList.viewAthleteAnswers = true;
            this._itemRightsList.viewCoachAnswers = true;
            // édition si l'évaluation est ouverte
            this._itemRightsList.edit = (evalAthlete.status === 'opened');
            this._itemRightsList.editAthleteAnswers = this._itemRightsList.edit;
            this._itemRightsList.editCoachAnswers = this._itemRightsList.edit;
            this._itemRightsList.delete = true;
            this._itemRightsList.close = true;
            this._itemRightsList.viewNotes = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un supercoach
            // tous les évaluations athlètes de son organisation
            if (evalAthlete && evalAthlete.organizationId === this._paramsItem.organizationId) {
                this._itemRightsList.view = true;
                this._itemRightsList.viewAthleteAnswers = true;
                this._itemRightsList.viewCoachAnswers = true;
                // édition si l'évaluation est ouverte
                this._itemRightsList.edit = (evalAthlete.status === 'opened');
                this._itemRightsList.editAthleteAnswers = this._itemRightsList.edit;
                this._itemRightsList.editCoachAnswers = this._itemRightsList.edit;
                this._itemRightsList.delete = true;
                this._itemRightsList.close = true;
                this._itemRightsList.viewNotes = true;
            }
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            // tous les évaluations athlètes ayant une relation avec lui
            const links = this._utils.findManyIn([evalAthlete.athleteId], this._paramsItem.athleteCoachRelations, 'athleteId');
            const coachIds = this._utils.getKeyValues(links, 'coachId');
            const me = this._utils.findIn(this._paramsItem.user.id, this._paramsItem.coaches, 'userId');

            if (coachIds.indexOf(me.id) > -1) {
                this._itemRightsList.view = true;
                this._itemRightsList.viewAthleteAnswers = true;
                this._itemRightsList.viewCoachAnswers = true;
                // édition si l'évaluation est ouverte
                this._itemRightsList.edit = (evalAthlete.status === 'opened');
                this._itemRightsList.delete = (evalAthlete.status === 'opened');
                this._itemRightsList.editAthleteAnswers = this._itemRightsList.edit;
                this._itemRightsList.editCoachAnswers = this._itemRightsList.edit;
                this._itemRightsList.close = true;
                this._itemRightsList.viewNotes = true;
            }
            break;

        case OrganizationRole.ID_ATHLETE:
            // this._paramsItem.user est un athlète
            const ath = this._utils.findIn(this._paramsItem.user.id, this._paramsItem.athletes, 'userId');

            if (ath.id === evalAthlete.athleteId) {
                // Il peut voir/éditer que ses évaluations si l'évaluation est au statut "ouvert".
                // Il peut éditer uniquement ses réponses si c'est ouvert.
                if (evalAthlete.status === 'opened') {
                    this._itemRightsList.view = true;
                    this._itemRightsList.viewAthleteAnswers = true;
                    this._itemRightsList.edit = true;
                    this._itemRightsList.editAthleteAnswers = true;
                }else{
                    // Il peut voir les évaluations du coach si l'évaluation est au statut "fermé".
                    this._itemRightsList.view = true;
                    this._itemRightsList.viewAthleteAnswers = true;
                    this._itemRightsList.viewCoachAnswers = true;
                }
            }
            break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            // idem que le coach mais en lecture seule
            const guestlinks = this._utils.findManyIn([evalAthlete.athleteId], this._paramsItem.athleteGuestRelations, 'athleteId');
            const guestIds = this._utils.getKeyValues(guestlinks, 'guestId');
            const guest = this._utils.findIn(this._paramsItem.user.id, this._paramsItem.guests, 'userId');

            if (guestIds.indexOf(guest.id) > -1) {
                this._itemRightsList.view = true;
                this._itemRightsList.viewAthleteAnswers = true;
                this._itemRightsList.viewCoachAnswers = true;
                this._itemRightsList.viewNotes = true;
            }
            break;

        default:
            // rien
        }
    }

    public evaluateScreenRights(params: EvaluationAthleteScreenRightsParams): void {

        /**
         * Détermine les droits que l'utilisateur possède
         * pour les commandes générales des écrans.
         */

        this._paramsScreen = params;
        this.setDefault();
        this.setBestOfRole();


        if(!this._screenRightsList) return;

        switch (this._bestOfScreenRight) {
        case OrganizationRole.ID_ADMIN:
            // this._paramsItem.user est un admin
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_SUPERCOACH:
            // this._paramsItem.user est un super-coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_COACH:
            // this._paramsItem.user est un coach
            this._screenRightsList.list = true;
            this._screenRightsList.add = true;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = true;
            break;

        case OrganizationRole.ID_ATHLETE:
            // this._paramsItem.user est un athlète
            this._screenRightsList.list = true;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = true;
            this._screenRightsList.delete = false;
            break;

        case OrganizationRole.ID_GUEST:
            // this._paramsItem.user est un invité
            this._screenRightsList.list = true;
            this._screenRightsList.add = false;
            this._screenRightsList.edit = false;
            this._screenRightsList.delete = false;
            break;

        default:
            // rien
        }
    }

    public getItemRightsList(): EvaluationAthleteItemRightsList {
      if(!this._itemRightsList) throw new Error('Item rights list is not defined');
        return this._itemRightsList;
    }

    public getScreenRightsList(): EvaluationAthleteScreenRightList {
      if(!this._screenRightsList) throw new Error('Screen rights list is not defined');
        return this._screenRightsList;
    }

    public getItemParams(): EvaluationAthleteItemRightsParams {
        if(!this._paramsItem) throw new Error('Item params is not defined');
        return this._paramsItem;
    }

    public getScreenParams(): EvaluationAthleteScreenRightsParams {
        if(!this._paramsScreen) throw new Error('Screen params is not defined');
        return this._paramsScreen;
    }

    public get LIST() {
        if (this._screenRightsList) {
            return this._screenRightsList.list;
        }
        return false;
    }

    public get ADD() {
        if (this._screenRightsList) {
            return this._screenRightsList.add;
        }
        return false;
    }

    public get EDIT() {
        if (this._screenRightsList) {
            return this._screenRightsList.edit;
        }
        return false;
    }

    public get DELETE() {
        if (this._screenRightsList) {
            return this._screenRightsList.delete;
        }
        return false;
    }

    private setDefault(): void {

        const defaultItemRights: EvaluationAthleteItemRightsList = {
            view: false,
            viewAthleteAnswers: false,
            viewCoachAnswers: false,
            edit: false,
            editAthleteAnswers: false,
            editCoachAnswers: false,
            delete: false,
            close: false,
            viewNotes: false,
        };
        this._itemRightsList = defaultItemRights;

        const defaultScreenRights: EvaluationAthleteScreenRightList = {
            list: false,
            add: false,
            edit: false,
            delete: false,
        };
        this._screenRightsList = defaultScreenRights;

        this._bestOfItemRight = 10000;
        this._bestOfScreenRight = 10000;
    }

    private setBestOfRole() {

        if (this._paramsItem && this._paramsItem.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsItem.rolesIds.length; i++) {
                if (this._paramsItem.rolesIds[i] < this._bestOfItemRight) {
                    this._bestOfItemRight = this._paramsItem.rolesIds[i];
                }
            }
        }

        if (this._paramsScreen && this._paramsScreen.rolesIds.length > -1) {
            for (let i = 0; i < this._paramsScreen.rolesIds.length; i++) {
                if (this._paramsScreen.rolesIds[i] < this._bestOfScreenRight) {
                    this._bestOfScreenRight = this._paramsScreen.rolesIds[i];
                }
            }
        }
    }
}

export interface EvaluationAthleteItemRightsList {
    view: boolean;
    viewCoachAnswers: boolean;
    viewAthleteAnswers: boolean;
    edit: boolean;
    editCoachAnswers: boolean;
    editAthleteAnswers: boolean;
    delete: boolean;
    close: boolean;
    viewNotes: boolean;
}

export interface EvaluationAthleteScreenRightList {
    list: boolean;
    add: boolean;
    edit: boolean;
    delete: boolean;
}

export interface EvaluationAthleteItemRightsParams {
    user: User;
    organizationId: number;
    evaluationAthlete: EvaluationAthlete;
    rolesIds: number[];
    athleteCoachRelations: AthleteCoach[];
    athleteGuestRelations: AthleteGuest[];
    athleteMemberships: OrganizationMembership[];
    coaches: Coach[];
    athletes: Athlete[];
    guests: Guest[];
}

export interface EvaluationAthleteScreenRightsParams {
    rolesIds: number[];
}
